// ============================================
// Educational content (Step 8)
// ============================================

import { supabase } from '../../lib/supabase';
import { throwWithContext } from './_shared';

export interface EducationalContent {
  id: string;
  category: string;
  beginnerTitle: string;
  beginnerBody: string;
  intermediateTitle: string;
  intermediateBody: string;
  advancedTitle: string;
  advancedBody: string;
  reviewedBy?: string;
  reviewedAt?: string;
  sourceUrl?: string;
}

export async function fetchEducationalContent(): Promise<EducationalContent[]> {
  const { data, error } = await supabase
    .from('educational_content')
    .select('*')
    .order('id');
  if (error) throwWithContext("Couldn't load educational content", error);
  return (data || []).map((row) => ({
    id: row.id,
    category: row.category,
    beginnerTitle: row.beginner_title,
    beginnerBody: row.beginner_body,
    intermediateTitle: row.intermediate_title,
    intermediateBody: row.intermediate_body,
    advancedTitle: row.advanced_title,
    advancedBody: row.advanced_body,
    reviewedBy: row.reviewed_by ?? undefined,
    reviewedAt: row.reviewed_at ?? undefined,
    sourceUrl: row.source_url ?? undefined,
  }));
}
